<template>
    <v-dialog
      v-model="dialog"
      max-width="350"
      persistent
    >
    <div v-if="error">
        <app-message :rang="rang"  :matn="error_message" ></app-message>
    </div>
      <v-card>
        <v-form
                ref="new_firma"
                v-model="valid"
                @submit.prevent="save"

            >
        <v-card-title class="text-h5">
          Новый поставщик
        </v-card-title>

        <v-card-text>

                <v-text-field
                v-model="new_firma.nom"
                :rules="nameRules"
                label="Название поставщика"
                required
                ></v-text-field>


                <v-text-field
                v-model="new_firma.tel"
                :rules="phoneRules"
                label="Телефон"
                required
                ></v-text-field>

                <v-select
                v-model="new_firma.kurb"
                :items="valuta"
                label="Валюта"
                :item-text="valuta.text"
                :item-value="valuta.value"
                solo
                required
                :rules="kurbRules"
              ></v-select>

              <v-text-field
                v-model="new_firma.old_dolg"
                label="Долг до программы"
                ></v-text-field>




        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="red darken-1"
            text
            @click="exit_new_firm_dialod"

          >
            Отмена
          </v-btn>

          <v-btn
            color="green darken-1"
            text
            type="submit"
            :disabled="!valid"
            :loading="loading"
          >
            Сохранить
          </v-btn>
        </v-card-actions>
    </v-form>
      </v-card>
    </v-dialog>
</template>

<script>
import axios from 'axios';
  export default {
    data () {
      return {
        new_firma: {
            nom: '',
            tel: '',
            kurb: '',
            old_dolg: 0,
        },
        loading: false,
        dialog: true,
        menu2: false,
        valid: false,
        valuta: [
            { text: 'Сомони', value: 1 },
            { text: 'Доллар', value: 2 },
            { text: 'Рубль', value: 3 },
          ],
        nameRules: [
            v => !!v || 'Поле обязательно для заполнения',
            v=> (v && v.length >= 3) || 'Название должно быть не менее 3 символов',

        ],
        phoneRules: [
            v => !!v || 'Поле обязательно для заполнения',
            v=> (v && v.length >= 9) || 'Номер должен быть не менее 9 символов',
            v => (v && /^\d+$/.test(v)) || 'Неверный формат номера телефона',
            v => (v && v.length == 9) || 'Неверный формат номера телефона',

        ],
        kurbRules: [
            v => !!v || 'Поле обязательно для заполнения',
        ],
        error: false,
        error_message: '',
        rang: '#500',
      }
    },

    methods: {
        save() {
            if(this.$refs.new_firma.validate()) {
                this.loading = true;
                axios.post('/api/new_firma', this.new_firma)
                .then(response => {
                    if(response.data.status) {
                        this.error = true;
                        this.error_message = response.data.message;
                        this.rang = '#4CAF50';
                        this.loading = false;
                        this.$emit('exit_from_new_firm_dialod');
                        setTimeout(() => {
                            this.dialog = false;
                            this.error = false;
                            this.error_message = '';
                        }, 1000);


                    } else {
                        this.error = true
                        this.error_message = "Ошибка при сохранении данных"
                        this.loading = false;
                        setTimeout(() => {
                            this.error = false
                            this.error_message = ''
                        }, 3000)
                    }
                })
                .catch(error => {
                    this.loading = false;
                    this.error = true
                    this.error_message = error.response.data.message
                    setTimeout(() => {
                        this.error = false
                        this.error_message = ''
                    }, 3000)
                })




            }else{
                this.loading = false;
                this.error = true;
                this.error_message = 'Проверьте правильность заполнения полей';
                setTimeout(() => {
                    this.error = false;
                    this.error_message = '';
                }, 3000);
            }

        },
        exit_new_firm_dialod(){
            this.dialog = false;
            this.$emit('exit_from_new_firm_dialod');
        }
    },
  }
</script>

<style>

</style>




